import { usePageMaskContext } from 'contexts/PageMaskContext';
import React from 'react';
import { useUserContext } from 'store';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHospital } from '@fortawesome/free-solid-svg-icons';

import './HomePage.css';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export function HomePage() {
  const { availablePages } = usePageMaskContext();
  const [user] = useUserContext();
  const history = useHistory();
  const { t } = useTranslation('PageMask');
  const availablePagesToDisplay = availablePages.filter(
    (element) => !element.doesNotAppearOnHome,
  );

  return (
    <div className="homePage-content">
      {/* {user.role.isProfessional
        && (

          <div className="organizationIconArea2">
            <FontAwesomeIcon icon={faHospital} />
            <p className="organizationName2">
              {`${user.userData.rolesPerOrganization[0].organizationAlias}`}
            </p>
          </div>
        )} */}

      <div className="homePage-title-container">
        <h1 className="pageTitle">
          Olá,
          {' '}
          {user?.name?.split(' ')[0]}
          !
        </h1>
        {user.role.isProfessional && (
          <div className="areaOrganization">
            <FontAwesomeIcon className="hospIcon" icon={faHospital} />

            <p className="nameOrg">
              {`${user.userData.rolesPerOrganization[0].organizationAlias}`}
            </p>
          </div>
        )}

      </div>

      {/* <p className="homePage-subTitle">
        {user.role.isProfessional
          && 'Registro no conselho de classe: Não encontrado'}
      </p> */}
      {/* { user.role.isProfessional
              && (
              <Tooltip
                title={`${user.userData.rolesPerOrganization[0].organizationName}`}
                arrow
                placement="top"
              >
                <div className="organizationIconArea">
                  <FontAwesomeIcon icon={faHospital} />
                  <p className="organizationName">
                    {`${user.userData.rolesPerOrganization[0].organizationAlias}`}
                  </p>
                </div>
              </Tooltip>
              )} */}

      <div className="homePage-pageItemsContainer">
        {availablePagesToDisplay.map((element, index) => (
          <div
            className={`card ${user.role.isProfessional && 'profissional-justify'}`}
            key={`homePage-pageItems-${index}`}
            onClick={() => history.push(element.path)}
            role="button"
            tabIndex={0}
          >
            <FontAwesomeIcon icon={element.icon} size="40" />
            <div className="pageText">
              <p className="pageName">{t(element.name)}</p>
              <p className="pageDescription">{t(element.description)}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
